import { createFileRoute } from '@tanstack/react-router';
import { RentalImportPage } from '@/features/rentals/pages/rental-import-page';
import { requireRentalShop } from '@/lib/rental-guard';

export const Route = createFileRoute('/_app/rentals_/import')({
  beforeLoad: requireRentalShop,
  component: RentalImportPage,
});
